module.exports = __webpack_public_path__ + "assets/img/scenic.060b4371.png";